import { IFaireMoney } from "@faire/web-api/indigofair/data/IFaireMoney";
import { ISO3166Alpha3 } from "@faire/web-api/indigofair/iso3166/ISO3166Alpha3";
import { selectLocalCurrency } from "@faire/web/common/money";
import { formatMoney, RoundingStrategy } from "@faire/web/common/money";

import { isLoggedInRetailer } from "@faire/retailer/lib/isLoggedInRetailer";
import { getSessionCountry } from "@faire/retailer/serialized-data/getSessionCountry";
import { useRetailerStore } from "@faire/retailer/stores/domain/RetailerStore";

const useIncentiveByLocale = (): IFaireMoney => {
  const { displayCurrency } = useRetailerStore(["displayCurrency"]);
  const sessionCountry = getSessionCountry();
  if (isLoggedInRetailer()) {
    return IFaireMoney.build({
      amount_cents: 100_00,
      currency: displayCurrency,
    });
  } else {
    return IFaireMoney.build({
      amount_cents: 100_00,
      currency: selectLocalCurrency(sessionCountry ?? ISO3166Alpha3.USA),
    });
  }
};

export const useIncentiveForLandingPages = () => {
  const formattedIncentive = useIncentiveByLocale();
  return formatMoney({
    money: formattedIncentive,
    roundingStrategy: RoundingStrategy.DROP_CENTS,
    disableAutoConvertCurrency: true,
  });
};
